<template>
  <div class="p-top__news">
    <div class="text-10">
      News
    </div>
    <a :href="permalink" class="p-top__news__body">
      <time class="pr-2 mr-2 border-r border-white leading-none">{{ date }}</time><p>{{ title }}</p>
    </a>
  </div>
</template>

<script>
import axios from 'axios'
const resource = 'wp-json/wp/v2/posts?per_page=1';
export default {
  name: "FrontPageNews",
  data(){
    return {
      post: {},
      title: '',
      date: '',
      permalink: '',
    }
  },
  async created() {
    const { data } = await axios.get(`${resource}`);
    this.post = data[0]
    console.log(data)
    this.title = this.post.title.rendered;
    this.date = this.post.date.split('T')[0].replaceAll('-','.');
    this.permalink = this.post.link
  }

}
</script>

<style scoped>
.p-top__news {
  max-width: 760px;
  @apply flex md:w-9/12 text-xs text-white absolute bottom-0 mb-4 ml-4;
  z-index: 5;
}

.p-top__news a{
  @apply hover:opacity-70 transition-opacity;
}

.p-top__news div{
  @apply mr-4 px-2 flex items-center text-gray-500 bg-white;
}

.p-top__news__body {
  @apply flex flex-col md:flex-row md:items-center justify-center;
}

.p-top__news__body p {
  line-height: 1;
}

</style>